import { render, staticRenderFns } from "./NeedPhds.vue?vue&type=template&id=806bdef6&scoped=true&"
import script from "./NeedPhds.vue?vue&type=script&lang=js&"
export * from "./NeedPhds.vue?vue&type=script&lang=js&"
import style0 from "./NeedPhds.vue?vue&type=style&index=0&id=806bdef6&prod&lang=css&"
import style1 from "./NeedPhds.vue?vue&type=style&index=1&id=806bdef6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806bdef6",
  null
  
)

export default component.exports